import LocalForage from 'localforage'

const LocalDatabase = {
  async set(name, token) {
    return await LocalForage.setItem(name, token)
  },
  async get(name) {
    return await LocalForage.getItem(name)
  },
  async remove(name) {
    return await LocalForage.removeItem(name)
  },
  async clear() {
    return await LocalForage.clear()
  }
}

export default LocalDatabase
